import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";

const StarRating = ({ number, value, onChange, readOnly = true, className = "" }) => {
	const count = value ?? number ?? 0;

	return (
		<div className={className}>
			<Rating
				value={count}
				onChange={onChange}
				readOnly={readOnly}
				style={{ maxWidth: 150 }}
			/>
		</div>
	);
};

export default StarRating;
